import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

// Renders an <a>, so it takes the standard anchor attributes — callers pass
// title/aria-* alongside href/target/rel and the component spreads them through.
interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  level?: 'nav';
  className?: string;
  style?: React.CSSProperties;
}

const LEVEL = {
  nav: 'text-type-gray text-base leading-normal font-medium tracking-[0.02em] no-underline hover:text-type-gray hover:underline',
};

const List = ({
  children,
  level = 'nav',
  className,
  ...props
}: IProps): ReactElement => {
  return (
    <a className={twMerge('list--nav', LEVEL[level], className)} {...props}>
      {children}
    </a>
  );
};

export default List;
